import { render, staticRenderFns } from "./ModalImportarItensLicitacao.vue?vue&type=template&id=8030b50c&scoped=true"
import script from "./ModalImportarItensLicitacao.vue?vue&type=script&lang=ts"
export * from "./ModalImportarItensLicitacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8030b50c",
  null
  
)

export default component.exports